import type React from "react";
import { ButtonsList } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/ButtonsList";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { i18nFilter } from "app/filters/i18nFilter";
import { getDefaultParamsForState } from "app/pages/digital-suite/home-page/helpers";
import type { IStepMetadata } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardUtils";
import { Step } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import { getWizardCustomData } from "app/pages/digital-suite/home-page/components/ActivationWizard/ActivationWizardApi";

export const CreateKeywordListStep: React.FC<IStepMetadata> = (props) => {
    const i18n = i18nFilter();

    const onCreateList = async (): Promise<void> => {
        const keyword = await getWizardCustomData(props.role, "keyword");
        props.onStepComplete("growth.homepage.wizard.button.createKeywordList");

        if (keyword) {
            proNavigator.go("digitalsuite_findkeywords_keywordGeneratorTool", {
                ...getDefaultParamsForState("digitalsuite_findkeywords_keywordGeneratorTool"),
                keyword,
                selectRows: true,
            });
        } else {
            proNavigator.go("digitalsuite_findkeywords_keywordGeneratorTool");
        }
    };

    return (
        <Step
            {...props}
            title={i18n("growth.homepage.activationWizard.step.create_keyword_list.title")}
            description={i18n("growth.homepage.activationWizard.step.create_keyword_list.description")}
            buttonsList={
                <ButtonsList
                    buttons={[
                        {
                            text: i18n("growth.homepage.activationWizard.step.create_keyword_list.button"),
                            onClick: onCreateList,
                            type: "primary",
                        },
                    ]}
                />
            }
        />
    );
};
